import findPeople from 'mini-people-hub-store/lib/services/findPeople';
import { measureFunctionPerf } from 'mini-performance/lib/utils/measureFunctionPerf';
import { DEFAULT_CONTACTS_FOLDER_ID } from 'mini-people-hub-store/lib/utils/constants';

export function triggerFetchForPeople() {
    const peopleArgs = {
        maxEntriesReturned: 50,
        offset: undefined,
        parentFolderId: DEFAULT_CONTACTS_FOLDER_ID,
        queryString: null,
        sorting: 0,
    };

    const findPeopleWithMeasure = measureFunctionPerf(findPeople, 'early_fp');
    findPeopleWithMeasure(peopleArgs);
}
